<template>
  <footer>
    <v-divider />
    <div class="d-flex flex-column justify-center align-center">
      <div class="justify-center align-center desktop partner-list">
        <v-img :src="partner1" width="60px" class="logo" :class="{'order-0': currentLanguage === 'lv', 'order-1':  currentLanguage !== 'lv'}"/>
        <v-img :src="partner2" width="60px" class="logo" :class="{'order-0': currentLanguage === 'est', 'order-2':  currentLanguage !== 'et'}"/>
        <v-img :src="partner3" width="60px" class="logo" :class="{'order-0': currentLanguage === 'mk', 'order-3':  currentLanguage !== 'mk'}"/>
        <v-img :src="eu" width="210px" class="logo order-4"/>
      </div>
      <div class="ma-2 text-center w-75">
        <p class="mx-2 text-subtitle-2">Erasmus+ project “Tools and techniques for a better choice of profession”, 2023-2-LV01-KA210-VET-000174014</p>
        <p class="mx-2 text-caption">Funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or the European Education and Culture Executive Agency (EACEA). Neither the European Union nor EACEA can be held responsible for them.</p>
        <p class="mx-2 mt-2">© CareerChoice {{ new Date().getFullYear() }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  data() {
    return {
      partner1: new URL("/src/assets/rvt.png", import.meta.url).href,
      partner2: new URL("/src/assets/voco.png", import.meta.url).href,
      partner3: new URL("/src/assets/parentija.png", import.meta.url).href,
      eu: new URL("/src/assets/eu.jpg", import.meta.url).href,
    }
  }
}
</script>

<style scoped>
footer {
  width: 100%;
  text-align: center;
  color: #a9a9a9;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.partner-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 4fr;
  gap: 10vw;
  max-width: 70vw;
  margin: auto;
  padding: 10px 0 5px 0;
}

@media only screen and (min-width: 1460px) {
  .desktop {
    display: none !important;
  }
}

@media only screen and (max-width: 1460px) {
  .desktop {
    display: flex !important;
  }
}

@media only screen and (max-width: 790px) {
  .desktop {
    flex-wrap: wrap;
  }
}

</style>